// extracted by mini-css-extract-plugin
export var boldText = "_87-4";
export var checkboxContainer = "_87-6";
export var closeIcon = "_87-i";
export var container = "_87-0";
export var drawer = "_87-8";
export var drawerContent = "_87-9";
export var extraSmallText = "_87-5";
export var fulfillmentGroupTable = "_87-e";
export var largeText = "_87-3";
export var loadingSpinnerContainer = "_87-j";
export var mediumText = "_87-2";
export var narrow = "_87-f";
export var notificationLink = "_87-l";
export var packageCheckIconContainer = "_87-7";
export var slideoutHeaderActions = "_87-g";
export var slideoutHeaderActionsShifted = "_87-h";
export var slideoutHeaderContainer = "_87-a";
export var slideoutModal = "_87-c";
export var stickyHeaderWrapper = "_87-b";
export var table = "_87-k";
export var tableContainer = "_87-d";
export var tertiaryText = "_87-1";